module.exports = __webpack_public_path__ + "static/img/v21ThreeDetailImg.3491df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21ThreeDetailImg.png
// module id = +9Tr
// module chunks = 1